import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { Result } from '@digibricks/core';
import { PARTICIPATED_ASSIGNMENT_API } from '../data-sources';
import { ParticipatedAssignmentResponder, PARTICIPATED_ASSIGNMENT_RESPONDER_REPOSITORY } from '../../core';
import { USER_API } from '@module/user';
export var ParticipatedAssignmentRepository = /*#__PURE__*/function () {
  function ParticipatedAssignmentRepository(assignmentApi, userApi) {
    _classCallCheck(this, ParticipatedAssignmentRepository);

    this.assignmentApi = assignmentApi;
    this.userApi = userApi;
  }

  _createClass(ParticipatedAssignmentRepository, [{
    key: "getParticipatedAssignmentPage",
    value: function () {
      var _getParticipatedAssignmentPage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.assignmentApi.getParticipatedAssignmentPage(query));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getParticipatedAssignmentPage(_x) {
        return _getParticipatedAssignmentPage.apply(this, arguments);
      }

      return getParticipatedAssignmentPage;
    }()
  }, {
    key: "getParticipatedAssignment",
    value: function () {
      var _getParticipatedAssignment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(queryParams) {
        var responseOrError, participatedAssignments, listUserIDs, userResponseOrError, userSummaries, participatedAssignmentsForResponderResponse, result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.assignmentApi.getParticipatedAssignment(queryParams);

              case 2:
                responseOrError = _context2.sent;

                if (!responseOrError.isFailure) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", Result.fail(responseOrError.error));

              case 5:
                participatedAssignments = responseOrError.getValue();

                if (participatedAssignments.length) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt("return", Result.ok([]));

              case 8:
                // get user summary
                listUserIDs = participatedAssignments.map(function (participatedAssignment) {
                  return participatedAssignment.toJsonObject().createdBy;
                });
                _context2.next = 11;
                return this.userApi.getUsers({
                  userIds: listUserIDs
                });

              case 11:
                userResponseOrError = _context2.sent;

                if (!userResponseOrError.isFailure) {
                  _context2.next = 14;
                  break;
                }

                return _context2.abrupt("return", Result.fail(userResponseOrError.error));

              case 14:
                userSummaries = userResponseOrError.getValue(); // map user summary to participated assignment

                participatedAssignmentsForResponderResponse = participatedAssignments.map(function (participatedAssignment) {
                  var _userSummaries$find$t, _userSummaries$find;

                  return _objectSpread(_objectSpread({}, participatedAssignment.toJsonObject()), {}, {
                    assigner: (_userSummaries$find$t = (_userSummaries$find = userSummaries.find(function (assigner) {
                      return assigner.id.toString() === participatedAssignment.createdBy;
                    })) === null || _userSummaries$find === void 0 ? void 0 : _userSummaries$find.toJsonObject()) !== null && _userSummaries$find$t !== void 0 ? _userSummaries$find$t : {
                      id: participatedAssignment.createdBy,
                      firstName: '',
                      lastName: ''
                    }
                  });
                });
                result = participatedAssignmentsForResponderResponse.map(function (participatedAssignment) {
                  return ParticipatedAssignmentResponder.fromJsonWithAssigner(participatedAssignment);
                });
                return _context2.abrupt("return", Result.combineArray(result));

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getParticipatedAssignment(_x2) {
        return _getParticipatedAssignment.apply(this, arguments);
      }

      return getParticipatedAssignment;
    }()
  }]);

  return ParticipatedAssignmentRepository;
}();
export var participatedAssignmentRepositoryProvider = {
  provide: PARTICIPATED_ASSIGNMENT_RESPONDER_REPOSITORY,
  useFactory: function useFactory(assignmentApi, userApi) {
    return new ParticipatedAssignmentRepository(assignmentApi, userApi);
  },
  inject: [PARTICIPATED_ASSIGNMENT_API, USER_API]
};